import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const contentType = 'multipart/form-data';

export const declarationsDocumentsContract = c.router({
  createDocument: {
    method: 'POST',
    path: '/declarations/create-document',
    body: z.object({ document: z.any(), lrn: z.string(), sequence: z.number().optional() }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  updateDocument: {
    method: 'POST',
    path: '/declarations/update-document',
    body: z.object({ document: z.any(), lrn: z.string(), sequence: z.number().optional() }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  deleteDocument: {
    method: 'POST',
    path: '/declarations/delete-document',
    body: z.object({ document: z.any(), lrn: z.string(), sequence: z.number().optional() }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  saveGoodsItemDocuments: {
    method: 'POST',
    path: '/declarations/:declarationId/save-goods-item-documents/:goodsId',
    pathParams: z.object({ declarationId: z.string(), goodsId: z.string() }),
    body: z.object({ documents: z.any() }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  uploadProvidedDocument: {
    method: 'POST',
    path: '/declarations/:id/upload-provided-document',
    contentType,
    pathParams: z.object({ id: z.string() }),
    body: z.object({ type: z.string(), referenceNumber: z.string(), description: z.string() }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  downloadProvidedDocument: {
    method: 'GET',
    path: '/declarations/:id/provided-documents/download/:fileName',
    pathParams: z.object({ id: z.string(), fileName: z.string() }),
    responses: {
      200: c.otherResponse({ contentType: 'application/octet-stream', body: z.unknown() }),
      404: z.object({ message: z.string() }),
    },
  },
  deleteProvidedDocument: {
    method: 'DELETE',
    path: '/declarations/:id/provided-documents/:documentId',
    pathParams: z.object({ id: z.string(), documentId: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  getScreenshot: {
    method: 'POST',
    path: '/declarations/getScreenshot',
    query: z.object({ url: z.string().optional() }),
    body: c.noBody(),
    responses: {
      200: c.otherResponse({ contentType: 'image/jpeg', body: z.unknown() }),
    },
  },
  manuallySetScreenshot: {
    method: 'POST',
    path: '/declarations/:id/manuallySetScreenshot',
    contentType,
    pathParams: z.object({ id: z.string() }),
    body: z.object({ goodItemId: z.string() }),
    responses: {
      200: z.object({ declaration: z.any() }),
    },
  },
  deleteScreenshot: {
    method: 'POST',
    path: '/declarations/:id/deleteScreenshot',
    contentType,
    pathParams: z.object({ id: z.string() }),
    body: z.object({ goodItemId: z.string() }),
    responses: {
      200: z.object({ declaration: z.any() }),
    },
  },
});
